<template>
  <div class="pe-semester-study-grade-add">
    <slot :toggle-visible="toggleVisible"></slot>
    <DataGridDialog :visible.sync="visible"
                    width="420px"
                    title="添加学年"
                    @open="handleReset">
      <div class="pe-semester-study-grade-add-dialog"
           v-loading="committing"
           element-loading-text="数据提交中，请稍等...">
        <div class="main-cont">
          <el-form size="mini"
                   label-width="72px">
            <el-form-item label="学年名称">
              <el-input v-model="form.name"
                        type="text"
                        placeholder="请填写学年名称"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="footer">
          <el-button size="mini"
                     type="primary"
                     :disabled="committing"
                     @click="handleApply">提交保存</el-button>
          <el-button size="mini"
                     type="default"
                     @click="handleClose">关闭窗口</el-button>
        </div>
      </div>
    </DataGridDialog>
  </div>
</template>

<script>
import DataGridDialog from '../../../../../../../../elements/grid/DataGridDialog'
export default {
  name: 'PeSemesterStudyGradeAdd',
  components: {
    DataGridDialog
  },
  data () {
    return {
      visible: false,
      form: {
        name: ''
      },
      committing: false
    }
  },
  methods: {
    toggleVisible () {
      this.visible = !this.visible
    },
    handleApply () {
      if (!this.form.name) {
        this.$message.warning('请填写学年名称')
        return
      }
      this.committing = true
      this.$ajax({
        url: '/workspace/manager/basic/peSemester/addStudyGrade',
        method: 'post',
        data: this.$qs.stringify(this.form)
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success(response.data['message'])
              this.handleClose()
              this.$nextTick(() => {
                this.$emit('add-success')
              })
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.committing = false
      })
    },
    handleClose () {
      this.visible = false
    },
    handleReset () {
      Object.keys(this.form).forEach(key => {
        this.form[key] = ''
      })
    }
  }
}
</script>

<style lang="scss">
  .pe-semester-study-grade-add {
    display: inline-block;
  }
  .pe-semester-study-grade-add-dialog {
    & > .main-cont {
      padding: 25px 15px;
      .el-form {
        .el-form-item {
          &:last-child {
            margin-bottom: 0;
          }
          .el-form-item__label {
            font-size: 12px;
          }
        }
      }
    }
    & > .footer {
      height: 52px;
      background-color: #fff;
      border-top: 1px solid rgba(0,0,0,.05);
      text-align: center;
      line-height: 50px;
    }
  }
</style>
